import React from 'react'
import { Field, PanelTitle } from './InventoryShared';

function WastageEntryPage({ items }) {
    return (
        <section className='inventory-panel inventory-form-page'>
            <PanelTitle title='Wastage Entry' />
            <div className='inventory-form-grid two-column'>
                <Field label='Item Name' type='select' options={items.map(item => item.name)} />
                <Field label='Quantity Wasted' type='number' placeholder='1' />
                <Field label='Reason' type='select' options={['Expired', 'Spoiled', 'Spilled']} />
            </div>
            <div className='inventory-upload-zone'>Upload Photo<br /><small>Attach proof of wastage</small></div>
            <div className='inventory-actions sticky'><button>Submit</button></div>
        </section>
    );
}

export default WastageEntryPage
